<template>
    <div id="sites">
        <AppBreadCrumb :paths="[{ title: $t('message.sites') }]" :select="true">
            <a-input-search
                v-model="searchText"
                :placeholder="$t('message.search')"
                class="search-input desktop-search"
                @search="onSearch"
            />
            <button class="mobile-search-trigger" @click="openMobileSearch">
                <md-icon>search</md-icon>
            </button>
            <a-button v-b-modal.site-form class="actionButtonBreadcrumb" @click="showNewModalForm">
                <md-icon>add</md-icon>
                {{ $t("message.newSite") }}
            </a-button>
            <a-button class="ml-2 actionButtonBreadcrumb" @click="showModal">
                <md-icon>add</md-icon>
                {{ $t("message.newSelfServiceSite") }}
            </a-button>
            <a-button
                class="ml-2 actionButtonBreadcrumb"
                @click="$router.push(`/sites/${mySite.clientAddress.split('.')[0]}`)"
            >
                My Site
            </a-button>

            <a-button class="ml-2 actionButtonBreadcrumb" @click="$router.push(`/sites-new`)"> Yeni UI </a-button>
        </AppBreadCrumb>

        <b-container fluid>
            <b-row>
                <b-col>
                    <div class="d-flex w-100 filterContainer">
                        <div class="ml-2 d-flex" style="padding-top: 16px; gap: 5px">
                            <b-form-group class="mb-1" style="width: 140px">
                                <datetime
                                    v-model="startDate"
                                    :placeholder="$t('message.startDate')"
                                    auto
                                    input-class="form-control rounded-0"
                                    type="datetime"
                                />
                            </b-form-group>
                            <b-form-group class="mb-1" style="width: 140px">
                                <datetime
                                    v-model="endDate"
                                    :placeholder="$t('message.endDate')"
                                    auto
                                    input-class="form-control rounded-0"
                                    type="datetime"
                                />
                            </b-form-group>
                        </div>
                        <div class="ml-2 d-flex flex-column" style="width: 200px">
                            <strong>Partner</strong>
                            <b-form-group class="custom-input mb-0">
                                <Multiselect
                                    v-model="filters.partner"
                                    :multiple="false"
                                    :options="PARTNERS"
                                    label="name"
                                    placeholder="Select Partner"
                                    track-by="value"
                                    @select="partnerSelectChanged"
                                >
                                </Multiselect>
                            </b-form-group>
                        </div>
                        <div class="ml-2 d-flex flex-column">
                            <strong>Enabled?</strong>
                            <b-form-group class="custom-input mb-2">
                                <select v-model="filters.enabled" class="form-control">
                                    <option :value="null">All</option>
                                    <option :value="'true'">Yes</option>
                                    <option :value="'false'">No</option>
                                </select>
                            </b-form-group>
                        </div>
                        <div class="ml-2 d-flex flex-column">
                            <strong>Suspended?</strong>
                            <b-form-group class="custom-input mb-2">
                                <select v-model="filters.suspended" class="form-control">
                                    <option :value="null">All</option>
                                    <option :value="'true'">Yes</option>
                                    <option :value="'false'">No</option>
                                </select>
                            </b-form-group>
                        </div>
                        <div class="ml-2 d-flex flex-column">
                            <strong>Integration?</strong>
                            <b-form-group class="custom-input mb-2">
                                <select v-model="filters.integration" class="form-control">
                                    <option :value="null">All</option>
                                    <option :value="'true'">Yes</option>
                                    <option :value="'false'">No</option>
                                </select>
                            </b-form-group>
                        </div>
                        <div class="ml-2 d-flex flex-column">
                            <strong>Plan</strong>
                            <b-form-group class="custom-input mb-2">
                                <a-select
                                    mode="tags"
                                    style="width: 100%"
                                    :token-separators="[',']"
                                    @change="handlePlanChange"
                                >
                                    <a-select-option v-for="item in plans" :value="item._id" :key="item._id">
                                        {{ item.title }} {{ item.altTitle }}
                                        {{ item.siteId ? "(Özel Plan)" : item.altTitle }}
                                    </a-select-option>
                                </a-select>
                            </b-form-group>
                        </div>
                        <!--                        <FilterToolBar @updateFilters="updateFilter($event)" />-->
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="table-scroll-wrapper">
                        <a-table
                            :key="'vtable-' + renderCount"
                            :columns="cols()"
                            :dataSource="getFilteredRows()"
                            :loading="isBusy"
                            :locale="{ emptyText: $t('message.noSiteYet') }"
                            :pagination="false"
                            :scroll="{ x: 'max-content' }"
                            class="custom-table2"
                            rowKey="_id"
                            @change="tableChange"
                        >
                        <div :key="'suspend'" :slot="'suspend'" slot-scope="data, item">
                            <div class="material-icons" v-if="item.suspend" style="color: #fd4848;">error</div>
                            <div class="material-icons" v-else style="color: #00b900;">check_circle</div>
                        </div>
                        <div :key="'createdDate' + $i18n.locale" :slot="'createdDate'" slot-scope="data, item">
                            {{ item.createdAt | date("DD/MM/YYYY HH:mm") }}
                        </div>
                        <div :slot="'lastLoginTSSlot'" key="lastLoginTSSlot" slot-scope="data, item">
                            {{ formatLastLoginTS(item.lastLoginTS) }}
                        </div>
                        <!--                        <div :slot="'balance.total'" key="balance.total" slot-scope="data, item">-->
                        <!--                            {{ item.balance ? item.balance.total : 0 }} ₺-->
                        <!--                        </div>-->
                        <!--                        <div :slot="'invoice.totalPrice'" key="invoice.totalPrice" slot-scope="data, item">-->
                        <!--                            {{ item.invoice.totalPrice || 0 }} ₺-->
                        <!--                        </div>-->
                        <div :key="'statusSlot' + $i18n.locale" :slot="'statusSlot'" slot-scope="data, item">
                            <md-switch
                                v-model="sites.data.find((x) => x._id === item._id).enable"
                                class="md-primary"
                                style="height: 22px; margin: 0"
                                @change="(e) => toggleState(item, e)"
                            >
                                <span v-if="item.enable">{{ $t("message.active") }}</span>
                                <span v-else>{{ $t("message.passive") }}</span>
                            </md-switch>
                        </div>

                        <div :key="'isIntegrated' + $i18n.locale" :slot="'isIntegrated'" slot-scope="data, item">
                            <md-icon v-if="isIntegrated(item)" class="text-success">done</md-icon>
                            <md-icon v-else class="text-danger">hourglass_empty</md-icon>
                        </div>
                        <div :key="'partner' + $i18n.locale" :slot="'partner'" slot-scope="data, item">
                            <span>{{ item.partner ? item.partner.name : "self" }}</span>
                        </div>

                        <div :key="'actionsSlot-' + $i18n.locale" :slot="'actionsSlot'" slot-scope="data, item">
                            <div class="d-flex w-100 justify-content-start">
                                <a-button class="actionButton d-flex align-items-center px-1" @click="edit(item._id)">
                                    <ActionEdit />
                                </a-button>
                                <a-button class="actionButton d-flex align-items-center px-1" @click="del(item)">
                                    <ActionDelete />
                                </a-button>
                                <a
                                    v-if="item.phone"
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'top',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :content="item.phone"
                                    :href="`tel:${item.phone}`"
                                    class="text-success d-flex px-1"
                                >
                                    <md-icon class="text-success">phone</md-icon>
                                </a>
                                <a
                                    v-if="item.rootUserEmail"
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'top',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :content="item.rootUserEmail"
                                    :href="`mailto:${item.rootUserEmail}`"
                                    class="text-success d-flex px-1"
                                >
                                    <md-icon class="text-primary">email</md-icon>
                                </a>
                                <a
                                    v-if="isIntegrated(item)"
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'top',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :content="customerDomains(item).join(', ')"
                                    class="text-success d-flex px-1"
                                    @click="openCustomerOrigins(item)"
                                >
                                    <md-icon class="text-info">open_in_new</md-icon>
                                </a>
                                <a
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'top',
                                        theme: isDarkMode ? 'light-border' : 'google',
                                    }"
                                    :href="`/sites/${item.siteAddress
                                        .replace('.beta.supsis.live', '')
                                        .replace('.local.supsis.live', '')
                                        .replace('.supsis.live', '')
                                        .replace('supsis.live', 'supsis')}`"
                                    class="text-success d-flex px-1"
                                    content="Show Detail"
                                    @click.prevent="
                                        $router.push(
                                            `/sites/${item.siteAddress
                                                .replace('.beta.supsis.live', '')
                                                .replace('.local.supsis.live', '')
                                                .replace('.supsis.live', '')
                                                .replace('supsis.live', 'supsis')}`
                                        )
                                    "
                                >
                                    <md-icon class="text-info">visibility</md-icon>
                                </a>
                            </div>
                        </div>
                    </a-table>
                    </div>
                    <div class="mt-3 d-flex justify-content-end">
                        <Pagination
                            :page-change="pageChange"
                            :page-sizes="pageSizes"
                            :total="sites.total"
                            pageSizeLocalStorageKey="sites-page-size"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div v-if="isMobileSearchOpen" class="mobile-search-overlay" @click.self="isMobileSearchOpen = false">
            <div class="mobile-search-modal">
                <input
                    ref="mobileSearchInput"
                    v-model="searchText"
                    type="text"
                    :placeholder="$t('message.search')"
                    class="mobile-search-input"
                    @keyup.enter="onMobileSearchSubmit"
                />
                <button class="mobile-search-submit" @click="onMobileSearchSubmit">
                    <md-icon>search</md-icon>
                </button>
                <button class="mobile-search-close" @click="isMobileSearchOpen = false">
                    <md-icon>close</md-icon>
                </button>
            </div>
        </div>
        <SiteCreateModalForm
            :edit-mode="editMode"
            :on-cancel="onModalFormCancel"
            :on-success="onModalFormSuccess"
            :updating-site="site"
            :visible="modalVisible"
            :is-modal-show="isNewModal"
            :close-modal="hideNewModalForm"
        />
        <Modal2
            id="selfServiceModal"
            :title="$t('message.newSiteForm')"
            v-if="isModalShow"
            :show-footer="false"
            @cancel="hideModal"
        >
            <b-form class="d-flex flex-column justify-content-center" @submit.prevent="createSelfServiceSite">
                <b-row>
                    <b-col md="12">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('message.subdomain')) != null,
                            }"
                        >
                            <label>{{ $t("message.subdomain") }}</label>
                            <md-input
                                v-model="selfService.subdomain"
                                v-validate="'required'"
                                :name="$t('message.subdomain')"
                            ></md-input>
                            <span class="md-suffix">.{{ selfServiceDomain }}</span>
                            <span class="md-error">{{ errors.first($t("message.subdomain")) }}</span>
                        </md-field>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('message.rootUserName')) != null,
                            }"
                        >
                            <label>{{ $t("message.rootUserName") }}</label>
                            <md-input
                                v-model="selfService.rootUserName"
                                v-validate="'required'"
                                :name="$t('message.rootUserName')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.rootUserName")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('message.rootUserEmail')) != null,
                            }"
                        >
                            <label>{{ $t("message.rootUserEmail") }}</label>
                            <md-input
                                v-model="selfService.rootUserEmail"
                                v-validate="'required'"
                                :name="$t('message.rootUserEmail')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.rootUserEmail")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('message.phone')) != null,
                            }"
                        >
                            <label>{{ $t("message.phone") }}</label>
                            <md-input v-model="selfService.phone" :name="$t('message.phone')"></md-input>
                            <span class="md-error">{{ errors.first($t("message.phone")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('message.password')) != null,
                            }"
                        >
                            <label>{{ $t("message.password") }}</label>
                            <md-input
                                v-model="selfService.password"
                                v-validate="'required'"
                                :name="$t('message.password')"
                                type="password"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.password")) }}</span>
                        </md-field>
                    </b-col>
                    <b-col md="3">
                        <md-field
                            :class="{
                                'md-invalid': errors.first($t('message.organizationName')) != null,
                            }"
                        >
                            <label>{{ $t("message.organizationName") }}</label>
                            <md-input
                                v-model="selfService.organizationName"
                                v-validate="'required'"
                                :name="$t('message.organizationName')"
                            ></md-input>
                            <span class="md-error">{{ errors.first($t("message.organizationName")) }}</span>
                        </md-field>
                    </b-col>
                </b-row>
                <b-col md="12">
                    <b-button :disabled="loading" type="submit" variant="primary">
                        <template v-if="!loading">
                            <span>{{ $t("message.save") }}</span>
                        </template>
                        <template v-else>
                            <font-awesome-icon icon="spinner" spin />
                        </template>
                    </b-button>
                    <b-button @click="hideModal">
                        <template>
                            {{ $t("message.cancel") }}
                        </template>
                    </b-button>
                </b-col>
            </b-form>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilAlt, faPlusCircle, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import { log2 } from "../../../utils/log2";
import * as _ from "lodash";
import { SELF_SERVICE_DOMAIN, tableSorter } from "../../../utils/utils";
import Pagination from "../../../components/Pagination.vue";
import ActionEdit from "../../../components/svg/ActionEdit.vue";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { filter, first, map } from "rxjs/operators";
import { getPersistenceData } from "../../../utils/persistenceStorage";
import ActionDelete from "../../../components/svg/ActionDelete.vue";
import moment from "moment";
import SiteCreateModalForm from "../../../components/SiteCreateModalForm.vue";
import { getAllPlans, lookupSites } from "../../../api/site";
import Multiselect from "vue-multiselect";
import Modal2 from "../../../components/common/Modal2.vue";
import FilterToolBar from "./components/FilterToolBar.vue";

library.add(faPencilAlt, faTimes, faPlusCircle, faSpinner);

const selfServiceInitialObject = {
    rootUserName: undefined,
    rootUserEmail: undefined,
    password: undefined,
    organizationName: undefined,
    subdomain: undefined,
};
const log = log2("Sites");
const PARTNERS = [
    { name: "All", value: "all" },
    { name: "Manual", value: "manuel" },
    { name: "Self Service", value: null },
    { name: "Ideasoft", value: "ideasoft" },
    { name: "Shopify", value: "shopify" },
    { name: "Tsoft", value: "tsoft" },
    { name: "TiciMax", value: "ticimax" },
    { name: "WordPress", value: "wordpress" },
    { name: "Vedubox", value: "vedubox" },
];
export default {
    name: "Sites",
    components: {
        ActionDelete,
        AppBreadCrumb,
        Pagination,
        ActionEdit,
        SiteCreateModalForm,
        Multiselect,
        Modal2,
        FilterToolBar,
    },
    data() {
        return {
            startDate: this.$route.query.startDate || null,
            endDate: this.$route.query.endDate || null,
            plans: {},
            PARTNERS,
            selfServiceDomain: SELF_SERVICE_DOMAIN,
            isBusy: true,
            loading: false,
            editMode: false,
            pageSizes: ["10", "25", "50", "100", "500", "1000"],
            searchText: this.$route.query.searchText || "",
            site: null,
            modalVisible: false,
            selfService: _.cloneDeep(selfServiceInitialObject),
            passwordConfirmation: "",
            filters: {
                partner:
                    PARTNERS.find((p) => p.value === this.$route.query.partner) ||
                    PARTNERS.find((p) => p.value === null),
                enabled: this.$route.query.enabled || null,
                suspended: this.$route.query.suspended || null,
                integration: this.$route.query.integration || null,
                plan: this.$route.query.plan || null,
            },

            sites: {
                total: 0,
                count: 0,
                data: [],
            },
            cols: () => [
                {
                    dataIndex: "suspend",
                    scopedSlots: { customRender: "suspend" },
                    title: "Suspend",
                    ...tableSorter("suspend", "string", this.currentSort),
                },
                {
                    dataIndex: "siteAddress",
                    title: this.$t("message.siteAddress"),
                    ...tableSorter("siteAddress", "string", this.currentSort),
                },
                {
                    dataIndex: "createdAt",
                    title: this.$t("message.createdDate"),
                    scopedSlots: { customRender: "createdDate" },
                    ...tableSorter("createdAt", "date", this.currentSort),
                },
                {
                    dataIndex: "partner",
                    title: this.$t("message.partner"),
                    scopedSlots: { customRender: "partner" },
                    ...tableSorter("partner.name", "string", this.currentSort),
                },
                {
                    dataIndex: "agentCount",
                    title: this.$t("message.agentCount"),
                    ...tableSorter("agentCount", "number", this.currentSort),
                },
                {
                    dataIndex: "lastLoginTS",
                    title: "Last Activity",
                    scopedSlots: { customRender: "lastLoginTSSlot" },
                    ...tableSorter("lastLoginTS", "number", this.currentSort),
                },
                // {
                //     dataIndex: "balance.total",
                //     title: "Balance",
                //     scopedSlots: { customRender: "balance.total" },
                //     ...tableSorter("balance.total", "number", this.currentSort),
                // },
                {
                    dataIndex: "isIntegrated",
                    title: this.$t("message.isIntegrated"),
                    scopedSlots: { customRender: "isIntegrated" },
                    ...tableSorter("integratedOrigins", "array_len", this.currentSort),
                },
                {
                    dataIndex: "rootUserName",
                    title: this.$t("message.name"),
                    ...tableSorter("rootUserName", "string", this.currentSort),
                },
                // {
                //     dataIndex: "paymentMethod",
                //     title: "Temsilci Sayısı",
                //     ...tableSorter("paymentMethod", "string", this.currentSort),
                // },
                // {
                //     dataIndex: "settings.plan.trialDays",
                //     title: "Deneme Gün Sayısı",
                //     ...tableSorter("settings.plan.trialDays", "string", this.currentSort),
                // },
                // {
                //     dataIndex: "invoice.totalPrice",
                //     title: "Ödenmemiş Fatura Tutarı",
                //     scopedSlots: { customRender: "invoice.totalPrice" },
                //     ...tableSorter("invoice.totalPrice", "number", this.currentSort),
                // },
                // {
                //     dataIndex: "basePrice.discount",
                //     title: "İndirim Oranı",
                //     ...tableSorter("basePrice.discount", "string", this.currentSort),
                // },
                {
                    dataIndex: "enable",
                    title: this.$t("message.status"),
                    scopedSlots: { customRender: "statusSlot" },
                    ...tableSorter("enable", "string", this.currentSort),
                },
                {
                    title: this.$t("message.transactions"),
                    scopedSlots: { customRender: "actionsSlot" },
                },
            ],
            perPage: !isNaN(getPersistenceData("sites-page-size") || "undefined")
                ? parseInt(getPersistenceData("sites-page-size"))
                : 1000,
            page: 1,
            renderCount: 0,
            currentSort: {
                columnKey: this.$route.query.columnKey || "createdAt",
                order: this.$route.query.order || "descend",
            },
            isModalShow: false,
            isNewModal: false,
            isMobileSearchOpen: false,
        };
    },
    computed: {
        ...mapState({
            loggedUser: (state) => state.auth.adminUser,
            adminUser: (state) => state.auth.adminUser,
            mySite: (state) => state.site.site,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
    },
    methods: {
        ...mapActions({
            getSite: "site/getSite",
            delSite: "site/delSite",
            updateSite: "site/updateSite",
        }),
        hideModal() {
            this.isModalShow = false;
        },
        showModal() {
            this.isModalShow = true;
        },
        showNewModalForm() {
            this.isNewModal = true;
            this.editMode = false;
        },
        hideNewModalForm() {
            this.isNewModal = false;
        },
        getFilteredRows() {
            let items = this.sites.data;
            log("filter", { f: this.filters.integration, typ: typeof this.filters.integration });
            if (typeof JSON.parse(`${this.filters.integration}`) === "boolean") {
                items = items.filter((site) => {
                    const domains = this.customerDomains(site);
                    return JSON.parse(`${this.filters.integration}`) ? domains.length > 0 : domains.length === 0;
                });
            }
            if (["free", "pro", "whatsapp", "whatsapp-business"].includes(this.filters.plan)) {
                items = items.filter((site) => {
                    return _.get(site, "settings.plan.selectedPlan", "") === this.filters.plan;
                });
            }
            console.log("getFilteredRows..", { items: JSON.stringify(items) });
            return items;
        },
        handlePlanChange(plan) {
            log("handlePlanChange", plan);
            this.filters.planIds = this.allPlans
                .filter((x) => plan.includes(x._id) || plan.includes(x.refPlan))
                .map((x) => x._id);
            this.get();
        },
        getPlans() {
            getAllPlans().then((plans) => {
                this.allPlans = plans;
                this.plans = plans.filter((x) => !x.siteId);
            });
        },
        partnerSelectChanged(partner) {
            log("partnerSelectChanged", partner);
        },
        onModalFormSuccess() {
            this.get();
            this.modalVisible = false;
        },
        onModalFormCancel() {
            log("onMoodalCancell Çalıştı!!!!!**********************");
            this.modalVisible = false;
        },
        customerDomains(site) {
            return site.integratedOrigins.filter((x) => x.indexOf(".supsis.live") === -1);
        },
        formatLastLoginTS(ts) {
            if (ts) return moment(ts).fromNow();
            else return "-";
        },
        openCustomerOrigins(site) {
            this.customerDomains(site).forEach((origin) => {
                window.open(`http://${origin}`, "_blank");
            });
        },
        isIntegrated(site) {
            return this.customerDomains(site).length > 0;
        },
        tableChange(pagination, filters, sorter) {
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log("show me current Sort", {
                currentSort: this.currentSort,
                newSort,
            });
            if (newSort.columnKey !== oldSort.columnKey || newSort.order !== oldSort.order) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.get();
            }
        },
        openMobileSearch() {
            this.isMobileSearchOpen = true;
            this.$nextTick(() => {
                if (this.$refs.mobileSearchInput) {
                    this.$refs.mobileSearchInput.focus();
                }
            });
        },
        onMobileSearchSubmit() {
            this.onSearch(this.searchText);
            this.isMobileSearchOpen = false;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            this.get();
        },
        pageChange(page, pageSize) {
            log("pageChange", { page, pageSize });
            this.page = page;
            this.perPage = pageSize;
            this.get();
        },
        onShowSizeChange(current, pageSize) {
            log("onShowSizeChange", current, pageSize);
            this.page = current;
            this.perPage = pageSize;
            this.get();
        },
        /*    updateFilter(breakdownFilter) {
            const filters = breakdownFilter.map((x) => {
                return {
                    name: x.name,
                    value: x.filterValue,
                };
            });
            this.get(filters);
        },*/
        get() {
            this.getPlans();
            this.isBusy = true;
            const pagination = { perPage: this.perPage, page: this.page };
            const sorting = {
                sortBy: this.currentSort.columnKey,
                sortOrder: this.currentSort.order,
            };
            const search = this.searchText;
            const filters = {
                "partner.name": this.filters.partner.value,
                enable: this.filters.enabled,
                suspend: this.filters.suspended,
            };
            if (this.filters.partner.value === "all") {
                delete filters["partner.name"];
            }
            if (this.filters.enabled === null) {
                delete filters.enable;
            }
            if (this.filters.suspended === null) {
                delete filters.suspend;
            }
            this.updateQueryParams("columnKey", sorting.sortBy);
            this.updateQueryParams("order", sorting.sortOrder);
            this.updateQueryParams("page", pagination.page);
            this.updateQueryParams("perPage", pagination.perPage);
            this.updateQueryParams("searchText", search);
            this.updateQueryParams("partner", this.filters.partner.value);
            this.updateQueryParams("enabled", filters.enable);
            this.updateQueryParams("suspended", filters.suspend);
            this.updateQueryParams("integration", this.filters.integration);
            this.updateQueryParams("planIds", this.filters.planIds);
            this.updateQueryParams("startDate", this.startDate);
            this.updateQueryParams("endDate", this.endDate);
            lookupSites(pagination, sorting, search, filters, this.startDate, this.endDate, this.filters.planIds).then(
                (response) => {
                    const { data, count, total } = response.data;
                    log("lookupSites", { data, count, total });
                    this.sites = {
                        data,
                        count,
                        total,
                    };
                    this.isBusy = false;
                }
            );
        },
        updateQueryParams(key, value) {
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
        edit(id) {
            this.editMode = true;
            this.site = _.cloneDeep(this.sites.data.find((site) => site._id === id));
            this.modalVisible = true;
            this.isNewModal = true;
        },
        del(item) {
            this.$dialog
                .confirm(this.$t("message.deleteSite", { siteName: _.get(item, "clientAddress") }), {
                    okText: this.$t("message.yes"),
                    cancelText: this.$t("message.no"),
                })
                .then(() => {
                    this.delSite(item._id).then((response) => {
                        this.sites.data = this.sites.data.filter((site) => site._id !== item._id);
                        this.sites.count -= 1;
                        this.sites.total -= 1;
                        sendSocketMessage("admin site-delete", { siteId: item._id });
                    });
                });
        },
        resetSelfServiceForm() {
            this.selfService = {
                ...selfServiceInitialObject,
            };
        },
        toggleState(site, newState) {
            this.sites.data = this.sites.data.map((x) => {
                if (x._id === site._id) {
                    x.enable = newState;
                    return x;
                }
                return x;
            });
            site.enable = newState;
            this.updateSite(site);
        },

        createSelfServiceSite() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    const payload = {
                        rootUserName: this.selfService.rootUserName,
                        rootUserEmail: this.selfService.rootUserEmail,
                        organizationName: this.selfService.organizationName,
                        subdomain: this.selfService.subdomain,
                        password: this.selfService.password,
                        partner: { name: "manuel" },
                        phone: this.selfService.phone,
                    };
                    socketMessageStream
                        .pipe(
                            filter((x) => x.cmd === "create_self_service_site_response"),
                            map((x) => x.data),
                            first()
                        )
                        .toPromise()
                        .then((response) => {
                            if (response.ok) {
                                /*this.$bvModal.hide("selfServiceModal");*/
                                this.hideModal();
                                this.$toasted.show(this.$t("message.siteSaved"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                                this.resetSelfServiceForm();
                                this.get();
                            } else {
                                console.error("create site error: ", response.error);
                                this.$toasted.error(this.$t("message.siteSaveError"), {
                                    duration: 3000,
                                    position: "bottom-center",
                                });
                            }
                        })
                        .finally((x) => {
                            this.loading = false;
                        });

                    sendSocketMessage("admin create-self-service-site", payload);
                }
            });
        },
    },
    mounted() {
        log("mounted", this.sites);
        this.get();
    },

    updated() {
        log("updated", this.sites);
        if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
    },
    beforeMount() {
        const isAccessEnabled =
            this.loggedUser.isFullAccess || this.loggedUser.approvedPages.some((page) => page.page === "sites");
        if (!isAccessEnabled) {
            this.$router.push("/denied");
        }
    },
    watch: {
        page(newValue, oldValue) {
            if (newValue) {
                this.get();
            }
        },
        perPage(newValue, oldValue) {
            if (newValue) {
                this.get();
            }
        },
        filters: {
            deep: true,
            handler: function (newValue, oldValue) {
                log("filters changed", newValue.partner, oldValue.partner);
                if (newValue.partner !== null) {
                    this.get();
                } else {
                    this.filters.partner = { name: "Self Service", value: null };
                    this.get();
                }
            },
        },
        startDate(newValue, oldValue) {
            if (newValue) {
                this.get();
            }
        },
        endDate(newValue, oldValue) {
            if (newValue) {
                this.get();
            }
        },
    },
};
</script>
<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
#sites {
    .multiselect__content-wrapper {
        min-height: 200px;
    }

    .multiselect__tag {
        padding: 1px 21px 5px 4px;
    }

    .multiselect__select {
        padding: 1px 13px 0px 0px;
        height: 24px;
        width: 8px;
    }

    .multiselect__tags {
        min-height: 30px !important;
        display: block;
        padding: 1px 25px 0px 7px !important;
        border-radius: 5px;
        border: 1px solid #e8e8e8;
        background: #fff;
        font-size: 14px;
    }

    .multiselect__tags-wrap {
        display: inline-flex;
    }

    .multiselect__placeholder {
        margin: 0;
    }

    .multiselect__tags {
        min-height: 30px !important;
        display: block;
        padding: 4px 38px 0 6px !important;
        border-radius: 5px;
        border: 1px solid #e8e8e8;
        background: #fff;
        font-size: 14px;
    }

    #site-form {
        button {
            float: right;
            margin-left: 10px;
        }
    }

    .filterContainer {
        padding: 14px;
        display: flex;
        align-items: center;
        gap: 15px;
        border-bottom: 1px solid #1e1e2d;
        flex-wrap: wrap;
    }

    .form-control {
        border-radius: 5px !important;
    }

    .ant-select-selection {
        width: 250px !important;
        max-height: 20px;
        overflow: auto;
    }

    .search-input {
        touch-action: manipulation;

        input,
        .ant-input-search-button,
        .ant-btn {
            touch-action: manipulation;
            pointer-events: auto !important;
            cursor: pointer;
        }
    }

    .desktop-search {
        display: block;
    }

    .mobile-search-trigger {
        display: none;
    }

    @media (max-width: 768px) {
        .desktop-search {
            display: none !important;
        }

        .mobile-search-trigger {
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 4px 6px;
            border-radius: 6px;
            touch-action: manipulation;

            .md-icon {
                color: #7c8db5;
                font-size: 22px !important;
            }

            &:active {
                background: rgba(0, 0, 0, 0.06);
            }
        }
    }

    .mobile-search-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 60px;

        .mobile-search-modal {
            background: #fff;
            border-radius: 12px;
            padding: 14px;
            width: 90%;
            max-width: 420px;
            display: flex;
            align-items: center;
            gap: 8px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);

            .mobile-search-input {
                flex: 1;
                border: 1px solid #e8e8e8;
                border-radius: 8px;
                padding: 10px 14px;
                font-size: 16px;
                outline: none;
                font-family: Poppins, sans-serif;
                touch-action: manipulation;

                &:focus {
                    border-color: #1890ff;
                }
            }

            .mobile-search-submit {
                background: #1890ff;
                border: none;
                border-radius: 8px;
                width: 42px;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                touch-action: manipulation;
                flex-shrink: 0;

                .md-icon {
                    color: #fff !important;
                    font-size: 20px !important;
                }
            }

            .mobile-search-close {
                background: #f5f5f5;
                border: none;
                border-radius: 8px;
                width: 42px;
                height: 42px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                touch-action: manipulation;
                flex-shrink: 0;

                .md-icon {
                    font-size: 20px !important;
                }
            }
        }
    }

    /**
     * Tablo için yatay scroll wrapper
     * Küçük ekranlarda tablonun sağa sola kaydırılabilmesini sağlar
     */
    .table-scroll-wrapper {
        width: 100%;
        overflow-x: auto;
        overflow-y: visible;
        -webkit-overflow-scrolling: touch; /* iOS için smooth scroll */

        /* Scrollbar stilleri (opsiyonel - daha iyi görünüm için) */
        &::-webkit-scrollbar {
            height: 8px;
        }

        &::-webkit-scrollbar-track {
            background: var(--color-border-default, #f0f0f0);
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;

            &:hover {
                background: #a8a8a8;
            }
        }
    }
}

#selfServiceModal {
    .ant-modal {
        width: 670px !important;
    }
}
</style>
